import type {ComponentClass} from 'react'
import {Route} from 'react-router-dom'
import {AppConfig} from '../AppConfig'
import {appUrl} from '../AppUrl'
import {ErrorBoundary} from '../components/ErrorBoundary'
import {ProtectClientSurveyInnerRoute} from '../modules/private/client_survey/components/ProtectClientSurveyInnerRoute'
import {AppPages} from './AppPages'
import {PrivateRoute} from './PrivateRoute'
import {PublicRoute} from './PublicRoute'

// Обертка на случай, если на странице произойдет ошибка при рендеринге.
const ErrorBoundaryComponent: ComponentClass = ErrorBoundary as unknown as ComponentClass

// Список путей ЛК пользователя приложения.
export function QuickAdvanceRoutes() {

    if (!AppConfig.features.advances?.quickAdvancePage) {
        return null
    }

    return (
        <>
            <Route
                path={appUrl().quickAdvance.landing}
                element={
                    <PublicRoute id="page-quick-advance-wrapper">
                        <AppPages.QuickAdvanceLandingPage />
                    </PublicRoute>
                }
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().quickAdvance.survey}
                element={
                    <PublicRoute
                        id="page-quick-advance-survey"
                        notReloadable
                    >
                        <AppPages.QuickAdvanceSurveyPage />
                    </PublicRoute>
                }
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().quickAdvance.quickAdCreation}
                element={
                    <PrivateRoute
                        id="page-quick-advance-item-creation"
                        notReloadable
                        loadingIndicatorDelay={2000}
                    >
                        <ProtectClientSurveyInnerRoute
                            clientSurveyPageUrl={appUrl().quickAdvance.survey}
                        >
                            <AppPages.QuickAdvanceAdSelectionPage />
                        </ProtectClientSurveyInnerRoute>
                    </PrivateRoute>
                }
                ErrorBoundary={ErrorBoundaryComponent}
            />

            <Route
                path={appUrl().quickAdvance.requestAdvanceForAd}
                element={
                    <PrivateRoute
                        id="page-quick-advance-request"
                        notReloadable
                        loadingIndicatorDelay={2000}
                    >
                        <ProtectClientSurveyInnerRoute
                            clientSurveyPageUrl={appUrl().quickAdvance.survey}
                        >
                            <AppPages.QuickAdvanceRequestPage />
                        </ProtectClientSurveyInnerRoute>
                    </PrivateRoute>
                }
                ErrorBoundary={ErrorBoundaryComponent}
            />
        </>
    )
}
